import Injectable from '@/modules/shared/domain/di/injectable';
import { CreateOnBoardingRepository } from '../../../domain/repository/create-on-boarding-repository';

@Injectable()
export default class CreateOnBoardingDummyRepository implements CreateOnBoardingRepository {
  execute(): Promise<void> {
    return Promise.resolve();
  }
}
